import { mapState } from 'vuex';

export default {
    name: 'confiememailhash',
    props: {
        hash : String
    },

    data : function(){

        return {
            loading : false,
            confirmed : false,
            fail : false
        }

    },

    created : function(){
        this.confirm()
    },

    watch: {
        //$route: 'getdata'
    },

    beforeRouteEnter (to, from, next) {
        next()
    },

    beforeRouteUpdate (to, from, next) {
        next()
    },

    computed: mapState({
        auth : state => state.auth,
    }),

    methods : {
        confirm : function(){

            if(this.hash){

                var t = this

                t.loading = true
                
                this.$root.user.verification.confirm.email(this.hash).then(function(){

                    t.loading = false
                    t.confirmed = true

                    t.$store.commit('icon', {
                        icon : 'success',
                        message : "Email was confirmed"
                    })

                }).
                catch(e => {

                    t.loading = false
                    t.fail = true

                    t.$store.commit('icon', {
                        icon : 'fail',
                        message : "Email has not confirmed"
                    })

                })

            }
            else{
                t.fail = true
            }

        }
    },
}